"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LogLevel_1 = require("./LogLevel");
/**
 * MultiLogger writes logs to multiple other loggers
 */


var MultiLogger = /*#__PURE__*/function () {
  function MultiLogger() {
    _classCallCheck(this, MultiLogger);

    for (var _len = arguments.length, loggers = new Array(_len), _key = 0; _key < _len; _key++) {
      loggers[_key] = arguments[_key];
    }

    this._loggers = loggers;
  }

  _createClass(MultiLogger, [{
    key: "info",
    value: function info(msg) {
      var _iterator = _createForOfIteratorHelper(this._loggers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var logger = _step.value;
          logger.info(msg);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "warn",
    value: function warn(msg) {
      var _iterator2 = _createForOfIteratorHelper(this._loggers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var logger = _step2.value;
          logger.warn(msg);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "error",
    value: function error(msg) {
      var _iterator3 = _createForOfIteratorHelper(this._loggers),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var logger = _step3.value;
          logger.error(msg);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "debug",
    value: function debug(debugFunction) {
      var message;
      var memoized;

      if (typeof debugFunction === 'string') {
        memoized = debugFunction;
      } else if (debugFunction) {
        memoized = function memoized() {
          if (!message) {
            message = debugFunction();
          }

          return message;
        };
      } else {
        memoized = '' + debugFunction;
      }

      var _iterator4 = _createForOfIteratorHelper(this._loggers),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var logger = _step4.value;
          logger.debug(memoized);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "setLogLevel",
    value: function setLogLevel(level) {
      var _iterator5 = _createForOfIteratorHelper(this._loggers),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var logger = _step5.value;
          logger.setLogLevel(level);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "getLogLevel",
    value: function getLogLevel() {
      var _iterator6 = _createForOfIteratorHelper(this._loggers),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var logger = _step6.value;
          return logger.getLogLevel();
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return LogLevel_1.default.OFF;
    }
  }]);

  return MultiLogger;
}();

exports.default = MultiLogger;